<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                :value="monto"
                type="number"
                label="Monto a Pagar"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="1">
              <v-text-field
                :value="numeroEstudiantes"
                type="number"
                label="N° Estudiantes"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                :value="montoTotal"
                type="number"
                label="Monto Total"
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-text-field
                v-model="form.numeroComprobante"
                type="number"
                label="N° Comprobante"
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.numeroComprobante" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-menu
                ref="menuFechaDepositoRef"
                v-model="menuFechaDeposito"
                transition="scale-transition"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaDeposito"
                    label="Fecha Depósito"
                    prepend-icon="mdi-calendar"
                    outlined
                    dense
                    hide-details
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"></v-text-field>
                </template>

                <v-date-picker v-model="form.fechaDeposito" no-title scrollable @input="menuFechaDeposito = false">
                  <v-spacer></v-spacer>

                  <v-btn text color="primary" @click="menu = menuFechaDeposito"> Cancelar </v-btn>

                  <v-btn text color="primary" @click="$refs.menuFechaDepositoRef.save(form.fechaDeposito)">
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <small v-for="error in errores.fechaDeposito" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <div class="d-flex">
                <v-file-input
                  v-model="archivo"
                  placeholder="Seleccione un archivo"
                  accept="image/jpeg, image/png, image/jpg, application/pdf"
                  label="Comprobante de Pago (JPG, PNG, PDF)"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="onFileChange"></v-file-input>

                <v-btn
                  class="ml-2"
                  title="Previsualizar archivo"
                  color="primary"
                  icon
                  :disabled="!archivo || !previsualizacion"
                  @click="verPrevisualizacionArchivo">
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="9" xl="10">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Estudiantes"
                small
                @click="$refs.modalFormularioDetallesSolicitudesPagos.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Estudiantes
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="item == null"
                title="Eliminar"
                @click="() => quitarItem(item.detalleSolicitudPagoId)">
                <v-icon>mdi-close</v-icon>

                Quitar
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoDetallesSolicitudesPagos
                ref="listadoRef"
                :items="form.detallesPagosUniversidades"
                :cargando="cargando"
                :universidadId="universidadId"
                @selectItem="selectItem" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="$refs.confirmacionRef.abrir">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />

    <ModalDetallesSolicitudesPagos
      ref="modalFormularioDetallesSolicitudesPagos"
      :nombreRecurso="nombreItem"
      :solicitudPagoId="form.solicitudPagoId"
      :detallesPagosUniversidades="form.detallesPagosUniversidades"
      :detallePagoConceptoUniversidadCuotaAnterior="detallePagoConceptoUniversidadCuotaAnterior"
      :inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior="
        inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior
      "
      :universidadId="universidadId"
      @agregarDetallesPagosUniversidades="agregarDetallesPagosUniversidades" />

    <ModalVerPdf ref="modalVerPdfRef" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import PagoUniversidadService from '../services/pago-universidad.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import ListadoDetallesSolicitudesPagos from './ListadoDetallesSolicitudesPagos.vue';
import layoutMixin from '../mixins/layout.mixin';
import ModalDetallesSolicitudesPagos from './ModalDetallesSolicitudesPagos.vue';
import cuotaAnteriorMixin from '../mixins/cuota-anterior.mixin';
import { concatenar } from '../utils/funciones';
import pagoUniversidadMixin from '../mixins/pago-universidad.mixin';

export default {
  name: 'ModalFormularioPagoUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin, layoutMixin, cuotaAnteriorMixin, pagoUniversidadMixin],
  components: {
    ConfirmacionAccion,
    ListadoDetallesSolicitudesPagos,
    ModalDetallesSolicitudesPagos,
  },
  props: {
    solicitudPagoId: {
      type: Number,
      required: true,
    },
    monto: {
      type: [Number, String],
      required: true,
    },
    detallePlanPagoConceptoUniversidadId: {
      type: [Number, null],
      required: true,
    },
    planPagoUniversidadId: {
      type: [Number, null],
      required: true,
    },
    universidadId: {
      type: [Number, null],
      required: true,
    },
  },
  computed: {
    numeroEstudiantes() {
      return this.form.detallesPagosUniversidades.length;
    },
    montoTotal() {
      return (this.monto * this.numeroEstudiantes).toFixed(2);
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Pago',
      menuFechaDeposito: false,
      confirmacion: {
        titulo: 'Guardar el Pago de la Universidad',
        mensaje: '¿Está seguro que desea realizar el pago de la universidad?',
        realizandoAccion: false,
        fnAceptar: () => this.validar(this.registrar, this.editar),
      },
      archivo: null,
    };
  },
  watch: {
    'form.numeroComprobante': function () {
      this.errores.numeroComprobante = [];
    },
    'form.fechaDeposito': function () {
      this.errores.fechaDeposito = [];
    },
    enviando: function (value) {
      this.confirmacion.realizandoAccion = value;
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      this.archivo = null;

      return {
        id: null,
        solicitudPagoId: this.solicitudPagoId,
        numeroComprobante: null,
        fechaDeposito: null,
        nombreDepositante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        depositanteId: this.$store.state.DATA_USER.id,
        detallesPagosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        solicitudPagoId: data.solicitudPagoId,
        numeroComprobante: data.numeroComprobante,
        fechaDeposito: data.fechaDeposito,
        nombreDepositante: data.nombreDepositante,
        depositanteId: data.depositanteId,
        detallesPagosUniversidades: data.detallesPagosUniversidades,
      };
    },
    abrir(accion, data = []) {
      const planPagoUniversidadId = this.planPagoUniversidadId;
      const detallePlanPagoConceptoUniversidadId = this.detallePlanPagoConceptoUniversidadId;

      Promise.all([
        this.obtenerDetallePagoConceptoUniversidadCuotaAnterior(
          planPagoUniversidadId,
          detallePlanPagoConceptoUniversidadId,
        ),
        this.obtenerPagosUniversidadesCuotaAnterior(planPagoUniversidadId, detallePlanPagoConceptoUniversidadId),
      ]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    guardar(accion) {
      const formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        if (key === 'detallesPagosUniversidades') {
          const detalles = this.form[key];

          Object.keys(detalles).forEach((key2) => {
            Object.keys(detalles[key2]).forEach((key3) => {
              if (key3 === 'detalleSolicitudPagoId' || key3 === 'observacion') {
                if (detalles[key2][key3]) {
                  formData.append(`${key}[${key2}][${key3}]`, detalles[key2][key3]);
                }
              }
            });
          });
        } else {
          if (this.form[key]) {
            formData.append(key, this.form[key]);
          }
        }
      });

      if (this.archivo) {
        formData.append('archivo', this.archivo);
      }

      this.guardarDatosMixin(
        PagoUniversidadService.create,
        PagoUniversidadService.update,
        accion,
        formData,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    agregarDetallesPagosUniversidades(detallesPagosUniversidades) {
      detallesPagosUniversidades.forEach((detalleSolicitudPago) => {
        const inscripcionProgramaUniversidad = detalleSolicitudPago.inscripcionProgramaUniversidad;
        const { inscripcion } = inscripcionProgramaUniversidad;
        const { estudiante, programa } = inscripcion;

        this.form.detallesPagosUniversidades.push({
          id: null,
          detalleSolicitudPagoId: detalleSolicitudPago.id,
          inscripcionProgramaUniversidad: {
            id: inscripcionProgramaUniversidad.id,
            inscripcion: {
              id: inscripcion.id,
              estudiante: {
                id: estudiante.id,
                nombres: estudiante.nombres,
                numeroDocumento: estudiante.numeroDocumento,
                primerApellido: estudiante.primerApellido,
                segundoApellido: estudiante.segundoApellido,
                sexo: estudiante.sexo,
                telefono1: estudiante.telefono1,
                telefono2: estudiante.telefono2,
                email: estudiante.email,
                profesiones: estudiante.profesiones,
                institucion: estudiante.institucion,
              },
              programaId: inscripcion.programaId,
              programa: {
                id: programa.id,
                nombreCompuesto: programa.nombreCompuesto,
                sedeId: programa.sedeId,
                sede: {
                  id: programa.sede.id,
                  nombre: programa.sede.nombre,
                },
              },
              estadoAcademicoId: inscripcion.estadoAcademicoId,
              estadoAcademico: inscripcion.estadoAcademico,
            },
          },
          observacion: null,
          creadoEn: null,
        });
      });
    },
    quitarItem(detalleSolicitudPagoId) {
      this.form.detallesPagosUniversidades = this.form.detallesPagosUniversidades.filter(
        (item) => item.detalleSolicitudPagoId !== detalleSolicitudPagoId,
      );
      this.item = null;
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>